import { render, staticRenderFns } from "./statisticCards.vue?vue&type=template&id=2bd4a27c&"
import script from "./statisticCards.vue?vue&type=script&lang=js&"
export * from "./statisticCards.vue?vue&type=script&lang=js&"
import style0 from "./statisticCards.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports